import { Pane } from './pane';
import * as cn from 'classnames';
import { ReactComponent as ArrowRight } from '../../assets/arrow-right.svg';
import { Button } from '../widgets/button/button';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import { useHover, useHoverDispatch } from '../../contexts/hover-context';
import { useNavigation } from '../../contexts/navigation-context';
import { useEffect, useState } from 'react';

export const EcosystemActivityPane = ({ ecosystemActivities: activities, ecosystemRoles: roles, onClose, visible }) => {
  const { to } = useNavigation();
  const { activityIds: selectedActivityIds, roleIds: selectedRoleIds } = useFilter();
  const dispatchFilter = useFilterDispatch();
  const [activity, setActivity] = useState();

  useEffect(() => {
    if (selectedActivityIds.length > 0) {
      setActivity(activities.find((a) => a.ID === selectedActivityIds?.[0]));
    }
  }, [selectedActivityIds]);

  const handleShowOrganizationsClicked = () => {
    to({ pageId: 'organization-search' });
  };

  const handleClose = () => {
    dispatchFilter({ type: 'activity-toggled', activityId: activity.ID });
  };

  return (
    <Pane visible={visible} onClose={handleClose}>
      <div className="paneSection">
        <div className="paneHint">Ecosystem Activity</div>
        <div className="paneTitle">{activity?.NAME}</div>
        <div className="paneDescription">{activity?.DESCRIPTION}</div>
      </div>
      <div style={{ marginTop: 32 }}>
        <Button size="normal" icon={<ArrowRight />} textAlign="left" color="highlight" onClick={handleShowOrganizationsClicked}>
          Show organizations
        </Button>
      </div>
    </Pane>
  );
};
